import Model, { attr } from '@ember-data/model';
import type { Type } from '@warp-drive/core-types/symbols';

export default class FavoriteModel extends Model {
  declare [Type]: 'favorite';
  @attr('string') declare type: string;
}
